import React from 'react'
import DrainSlitComplaintReportView from './DrainSlitComplaintReportView'
import ExportDrainSlitComplaintExcel from './ExportDrainSlitComplaintExcel'
import ExportDrainSlitComplaintPdf from './ExportDrainSlitComplaintPdf'

const DrainSlitRootComponent = () => {
  return (
   <>
   <div className="content text-start">
      <div className="page-content">
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
          <div>
            <h5 className="mb-1 fw-semibold">Drain Slit Complaint Report Information</h5>
            <p className="text-muted mb-0">
            Monitor and manage drain silt complaints across all wards.
            </p>
          </div>
          <div className="d-flex gap-2">
            <ExportDrainSlitComplaintExcel />
            <ExportDrainSlitComplaintPdf />
          </div>
        </div>
        <DrainSlitComplaintReportView />
       
      </div>
    </div >
   </>
  )
}

export default DrainSlitRootComponent
